import React from "react";
import ReactMarkdown from "react-markdown";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Signature from "./Signature";
import TechIssues from "./TechIssues";
import CaregiverSignature from "./CaregiverSignature";

const ViewNoteDetails = (props) => {
  const { classes, note, responseNote, templateText, techIssues, noteRef } = props;
  const theme = useTheme();

  const markdownComponents = {
    // disallow images and links for safety concerns:
    img: () => null,
    a: ({ children }) => <>{children}</>,
    p: ({ children }) => (
      <Typography variant="body2" sx={{ lineHeight: 1.6, margin: 0 }}>
        {children}
      </Typography>
    ),
    h1: ({ children }) => <Typography variant="h5">{children}</Typography>,
    h2: ({ children }) => <Typography variant="h6">{children}</Typography>,
    h3: ({ children }) => (
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{children}</Typography>
    ),
    h4: ({ children }) => (
      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>{children}</Typography>
    ),
    li: ({ children }) => (
      <Typography component="li" variant="body2" sx={{ lineHeight: 1.6 }}>
        {children}
      </Typography>
    ),
  };

  return (
    <div className={classes.noteDetailsContainer}>
      {techIssues ? (
        <TechIssues {...props} />
      ) : (
        <>
          {templateText.noteBlockTitle && (
            <div className={classes.noteDetail} ref={noteRef}>
              <div className={classes.noteDetailTitleContainer}>
                <div className={classes.noteDetailTitle}>
                  <Typography component="p" variant="subtitle1">
                    {templateText.noteBlockTitle}
                  </Typography>
                </div>
                <Typography component="p" variant="body2Secondary">
                  {templateText.noteBlockInstruction}
                </Typography>
              </div>
              <ReactMarkdown components={markdownComponents}>
                {note || ""}
              </ReactMarkdown>
            </div>
          )}
          {templateText.responseBlockTitle && (
            <div className={classes.noteDetail} ref={noteRef}>
              <div className={classes.noteDetailTitleContainer}>
                <div className={classes.noteDetailTitle}>
                  <Typography component="p" variant="subtitle1">
                    {templateText.responseBlockTitle}
                  </Typography>
                </div>
                <Typography component="p" variant="body2Secondary">
                  {templateText.responseBlockInstruction}
                </Typography>
              </div>
              <ReactMarkdown components={markdownComponents}>
                {responseNote || ""}
              </ReactMarkdown>
            </div>
          )}
          <Signature {...props} />
          <CaregiverSignature
            billableItem={props.billableItem}
            classes={classes}
            startDate={props.startDate}
            endDate={props.endDate}
            timezone={props.customerDetails?.timezone}
          />
        </>
      )}
    </div>
  );
};

export default ViewNoteDetails;
